"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firestoreToPlainObject = void 0;
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const isFirestoreTimestamp_1 = require("./isFirestoreTimestamp");
const firestoreToPlainObject = (documentSnapshot) => {
    const data = documentSnapshot.data();
    if (!data)
        throw new Error('unexpected empty data');
    return {
        ...mapValues_1.default(data, value => {
            if (isFirestoreTimestamp_1.isFirestoreTimestamp(value)) {
                return value.toDate().toISOString();
            }
            return value;
        }),
        id: documentSnapshot.id,
    };
};
exports.firestoreToPlainObject = firestoreToPlainObject;
//# sourceMappingURL=firestoreToPlainObject.js.map